var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"logout-modal","title":"Ready to Leave?"},on:{"ok":function($event){return _vm.$emit('logout')}}},[_c('p',[_vm._v("Click Ok to end your current session.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }